module.exports = __webpack_public_path__ + "static/media/a5.3ae38faf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/a5.png
// module id = 177
// module chunks = 108